/** Pounds to whole pence, and back. Money is stored and calculated in pence. */
export const toPence = (pounds: number) => Math.round(pounds * 100);
export const toPounds = (pence: number) => pence / 100;

const whole = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 });
const exact = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** £12,345 from pence, with a true minus sign. Pass exact for pence. */
export function money(pence: number | null | undefined, opts: { exact?: boolean; sign?: boolean } = {}): string {
  if (pence === null || pence === undefined || !isFinite(pence)) return "—";
  const v = Math.abs(pence) / 100;
  const s = (opts.exact ? exact : whole).format(opts.exact ? v : Math.round(v));
  if (pence < 0 && Math.round(Math.abs(pence) / (opts.exact ? 1 : 100)) !== 0) return `−${s}`;
  if (opts.sign && pence > 0) return `+${s}`;
  return s;
}
